import Decimal from 'decimal.js';
import { CargoContent } from 'src/types/ViewModel/Stowage/Manifest/CargoContent';

export const getCargoContentWeight = (cargoContents: CargoContent[]): Decimal => {
    return cargoContents.reduce((acc, cargoContent) => acc.add(cargoContent.weight), new Decimal(0));
};
